// extracted by mini-css-extract-plugin
export var dividerLine = "_56-3";
export var itemImage = "_56-9";
export var lightDivider = "_56-4";
export var modalContent = "_56-5";
export var modalContentCompact = "_56-6";
export var productCard = "_56-a";
export var productImage = "_56-b";
export var productImageCompact = "_56-7";
export var productImagePlaceholder = "_56-c";
export var productImagePlaceholderCompact = "_56-8";
export var progressBarBackground = "_56-1";
export var progressBarContainer = "_56-0";
export var progressBarFill = "_56-2";